import { Link } from "react-router-dom";
import { Bot, ChevronDown, WalletCards } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useWallet } from "@/context/WalletContext";
import { useProviderVault } from "@/context/ProviderContext";

const shortAddress = (address: string) => `${address.slice(0, 6)}…${address.slice(-4)}`;

export function AppHeader({ onOpenProvider }: { onOpenProvider: () => void }) {
  const { address, connect, disconnect, connecting, error } = useWallet();
  const { secret, hasSavedSecret, unlock, busy } = useProviderVault();

  return (
    <header className="sticky top-0 z-40 border-b border-white/10 bg-[#080910]/88 backdrop-blur-xl">
      <div className="mx-auto flex h-16 max-w-[1480px] items-center justify-between gap-4 px-4 sm:px-6">
        <Link className="group flex items-center gap-3" to="/">
          <span className="grid size-9 place-items-center rounded-xl border border-cyan-300/35 bg-cyan-300/10 text-cyan-200 shadow-[0_0_24px_rgba(69,242,221,.18)]">A</span>
          <span>
            <span className="block text-sm font-black tracking-[0.2em] text-white">ANISOUL</span>
            <span className="hidden text-[10px] tracking-[0.18em] text-white/45 sm:block">ON-CHAIN COMPANIONS</span>
          </span>
        </Link>

        <nav className="hidden items-center gap-6 text-sm text-white/60 md:flex">
          <Link className="transition hover:text-cyan-200" to="/create">Create</Link>
          <a className="transition hover:text-cyan-200" href="https://sepolia.basescan.org" rel="noreferrer" target="_blank">Base Sepolia</a>
          <span className="rounded-full border border-emerald-300/20 bg-emerald-300/8 px-3 py-1 text-[11px] font-bold tracking-wider text-emerald-200">ON-CHAIN ART</span>
        </nav>

        <div className="flex items-center gap-2">
          <Button
            className="hidden border-white/10 bg-white/5 text-white hover:bg-white/10 sm:flex"
            onClick={() => {
              if (hasSavedSecret && !secret) void unlock();
              else onOpenProvider();
            }}
            size="sm"
            variant="outline"
          >
            <Bot className="size-4" />
            {busy ? "Unlocking" : secret ? "AI ready" : hasSavedSecret ? "Unlock AI" : "Set AI"}
          </Button>
          {address ? (
            <Button className="bg-cyan-300 text-[#06100f] hover:bg-cyan-200" onClick={disconnect} size="sm">
              <WalletCards className="size-4" /> {shortAddress(address)} <ChevronDown className="size-3" />
            </Button>
          ) : (
            <Button className="bg-cyan-300 text-[#06100f] hover:bg-cyan-200" disabled={connecting} onClick={() => void connect()} size="sm">
              <WalletCards className="size-4" /> {connecting ? "Connecting" : "Connect"}
            </Button>
          )}
        </div>
      </div>
      {error && <div className="border-t border-red-400/15 bg-red-400/8 px-4 py-2 text-center text-xs text-red-200">{error}</div>}
    </header>
  );
}
